import React, { useEffect, useState } from "react";
import MenuList from "../../components/restaurant/menu/MenuList";
import api from "../../utils/api";
import { FaTh, FaList } from "react-icons/fa";
import TableSearch from "../../components/common/TableSearch";
import Pagination from "../../components/common/Pagination";
import { usePagination } from "../../hooks/usePagination";

const RestaurantMenus = () => {
  const [menus, setMenus] = useState([]);
  const [view, setView] = useState(() => localStorage.getItem("preferred_menu_view") || "list");

  useEffect(() => {
    localStorage.setItem("preferred_menu_view", view);
  }, [view]);

  const {
    currentPage,
    setCurrentPage,
    pageSize,
    setPageSize,
    searchTerm,
    setSearchTerm,
    paginatedData,
    totalItems,
    totalPages,
  } = usePagination(menus, ["translations.en.title", "translations.hi.title", "title", "description"]);

  useEffect(() => {
    // Fetch your menu list here with a high limit to show all items
    api.get("restaurant/restaurant/menu/all?limit=1000").then((res) => {
      //  showToast(res);
       if (res.success) {
         setMenus(res.data || []);
      }
    });
  }, []);

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold mb-4">Restaurant Menus</h1>
        <div className="flex flex-col sm:flex-row items-center gap-4 w-full">
          <TableSearch value={searchTerm} onChange={setSearchTerm} placeholder="Search menus..." className="flex-1 w-full" />
          <div className="flex items-center gap-2 w-full sm:w-auto justify-end">
            <button
            className={`p-2 rounded-md transition-colors ${
              view === "list" ? "bg-gray-300 text-gray-800" : "bg-gray-100 text-gray-600 hover:bg-gray-200"
            }`}
            onClick={() => setView("list")}
            title="List View"
          >
            <FaList />
          </button>
          <button
            className={`p-2 rounded-md transition-colors ${
              view === "grid" ? "bg-gray-300 text-gray-800" : "bg-gray-100 text-gray-600 hover:bg-gray-200"
            }`}
            onClick={() => setView("grid")}
            title="Grid View"
          >
            <FaTh />
          </button>
          </div>
        </div>
      </div>
      <MenuList items={paginatedData} view={view} />
      
      {menus.length > 0 && (
        <div className="mt-6 bg-white rounded-xl shadow-sm p-2">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalItems={totalItems}
            pageSize={pageSize}
            onPageChange={setCurrentPage}
            onPageSizeChange={setPageSize}
          />
        </div>
      )}
    </div>
  );
};

export default RestaurantMenus;
